<template>
  <section class="p-3 mt-2">
    <div class="shadow h-full p-3 rounded-lg">
      <h3 class="text-gray-dark font-bold text-md mb-3">Post</h3>
      <UserPostList :data="posts" :handlePostLike="handlePostLike" />
    </div>
  </section>
</template>

<script>
import UserPostList from "@/components/UserPostList";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TrainerPost",
  components: {
    UserPostList,
  },
  data() {
    return {
      posts: [],
    };
  },
  computed: {
    ...mapGetters(["userTrainerPosts"]),
    statePosts: function () {
      return this.userTrainerPosts;
    },
  },
  methods: {
    ...mapActions(["getUserTrainerPosts", "postCommentLike"]),
    async handlePostLike(id, isLiked) {
      if (this.getToken()) {
        let is_liked = "";
        let likeCounter = "";
        if (isLiked) {
          is_liked = 1;
          likeCounter = 1;
        } else {
          is_liked = null;
          likeCounter = -1;
        }
        const data = {
          is_liked: 1,
          post_id: id,
        };

        this.posts.map((item) => {
          if (item.id === id) {
            item.is_liked = is_liked;
            item.like_counter = item.like_counter + likeCounter;
          }
        });
        await this.postCommentLike(data);

        await this.getUserTrainerPosts(this.$route.params.trainer_id);
      }
    },
  },
  async created() {
    await this.getUserTrainerPosts(this.$route.params.trainer_id);
    if (this.userTrainerPosts !== null) {
      this.posts = [...this.userTrainerPosts];
    } else {
      this.posts = [];
    }
  },
  watch: {
    statePosts: function () {
      this.posts = this.userTrainerPosts || [];
    },
  },
};
</script>
